<div class="md-page">

    <!-- ── Page header ───────────────────────────────── -->
    <div class="md-header">
        <h2 class="md-title">Model details</h2>
    </div>

    <!-- ── Card ─────────────────────────────────────── -->
    <div class="md-card">
        <app-table-component
            [data]="carsList()"
            [columns]="tableColumns"
            [totalRecords]="totalRecords()"
            [rows]="rows"
            [first]="first"
            (pageChange)="onPageChange($event)"
            (searchChange)="onSearchChange()"
            [showColumnSelector]="false"
            [showClearFilters]="false"
            [searchControl]="searchControl" />
    </div>

</div>
